/**
 * [mutations description]
 * @type {Object}
 */
var mutations = {
  setVisible(state, visible) {
    state.visible = visible
  },
  setCheckInDate(state, checkInDate) {
    state.checkInDate = checkInDate
  },
  setCheckOutDate(state, checkOutDate) {
    state.checkOutDate = checkOutDate
  },
  setOnlyBooking(state, onlyCanBooking) {
    state.onlyCanBooking = onlyCanBooking
  },
  setPromotionId(state, promotionId) {
    state.promotionId = promotionId
  },
  setIsLoading(state, loading) {
    state.isLoading = loading
  }
}

export default mutations
